exports.tDocAPI = {
    //url: 'https://localhost:44379/api/'
    //url: 'https://localhost:44366/api',
    //url: 'https://tdoc-api-test.gls.dk/api/',
    url: 'https://tdoc-api.gls.dk/api/',
  };
  
  